import React, { useEffect, useState } from "react";
import { Container, Row, Col, Image, Badge } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";
import { CiCalendar } from "react-icons/ci";
import API from "../config/axios";
import { api_paths } from "../config/api.paths";
import { useDispatch } from "react-redux";
import { SET_LOADING } from "../redux/user";
import DefaultPhoto from "../assets/images/contactus/defaultavatar.png";

const IMG_PATH = process.env.REACT_APP_IMAGE_BASEURL || "";

const PastPresidentDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [presidentData, setPresidentData] = useState(null);
  const fetchPresidentDetails = async (id) => {
    dispatch(SET_LOADING(true));
    try {
      const response = await API.get(
        `${api_paths.member.PAST_PRESIDENTS.GET_DETAILS}/${id}`
      );
      // console.log("past president Data:", response.data);

      const data = response.data?.payload || [];
      setPresidentData(data);
      dispatch(SET_LOADING(false));
    } catch (error) {
      console.error("Error fetching events:", error);
    } finally {
      dispatch(SET_LOADING(false));
    }
  };

  useEffect(() => {
    if (id) {
      fetchPresidentDetails(id);
    }
    // eslint-disable-next-line
  }, [id]);

  return (
    <Container className="py-5">
      {/* BACK BUTTON */}
      <Row className="mb-4">
        <Col>
          <div className="d-flex align-items-center">
            <IoArrowBack
              onClick={() => navigate(-1)}
              className="cursor-pointer fs-3"
            />
          </div>
        </Col>
      </Row>

      {/* CONTENT */}
      <Row className="gy-4 mt-3">
        {/* IMAGE */}
        <Col md={3} lg={3}>
          <Image
            src={
              presidentData?.picture_path
                ? `${IMG_PATH}${presidentData?.picture_path}`
                : DefaultPhoto
            }
            alt={presidentData?.name}
            fluid
            rounded
            className="border shadow-sm"
          />
        </Col>

        {/* DETAILS */}
        <Col md={9} lg={9}>
          {/* NAME */}
          <h2
            className="fw-bolder mb-2"
            style={{
              fontSize: "2rem",
              minHeight: 60,
            }}
          >
            {presidentData?.name}
          </h2>

          {/* BADGE */}
          <Badge
            bg="warning-subtle"
            text="warning"
            className="mb-3 fw-normal p-2"
          >
            Past Presidents
          </Badge>

          {/* DATE */}
          <div className="d-flex align-items-center text-muted mb-3">
            <CiCalendar className="me-2 fs-3 text-warning" />
            <span className="fw-semibold">
              {presidentData?.start_year}
              {presidentData?.end_year &&
                presidentData.end_year !== presidentData.start_year && (
                  <> - {presidentData.end_year}</>
                )}
            </span>
          </div>

          {/* BIO */}
          <p className="text-muted" style={{ lineHeight: 1.7 }}>
            {presidentData?.description}
          </p>

          {/* KEY CONTRIBUTIONS */}
          {presidentData?.key_contributions && (
            <div className="mt-4">
              <h5 className="fw-bold mb-3">Key Contributions</h5>
              <p style={{ whiteSpace: "pre-line", lineHeight: 1.7 }}>
                {presidentData?.key_contributions}
              </p>
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default PastPresidentDetail;
